import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import { IpexMomentEnum } from '@insights/insights-data-provider';
const moduleId = 'add_to_list';
/**
 * Tracks events from Add to list and sends them to a reporter.
 *
 * @event click When add to cart or add to wishlist buttons are clicked.
 */
export default class AddToListTracker extends AbstractAnalyticsTracker {
    constructor(options) {
        super({ moduleId, ...options });
        this.context = options.context;
    }
    /**
     * Call to report when clicking to add products to the shopping list.
     */
    sendAddToListClick() {
        const payload = {
            common: { component: moduleId },
            data: {
                action: 'add_to_wishlist'
            },
            context: this.context
        };
        this.getReporter().report({
            event: 'click',
            ipexMoment: IpexMomentEnum.giveMe,
            payload
        });
    }
}
//# sourceMappingURL=AddToListTracker.js.map